import {Link} from "react-router-dom";

export default function Footer({className, ...props}) {

    return (
        <footer className={`border-t-[1px] flex flex-col lg:flex-row px-4 py-1 ${className}`}>
            <p className={"text-gray-400 text-sm flex-1 text-center lg:text-start"}>
                © 2023 All Copyrights reserved
            </p>
            <p className={"text-center text-gray-500 "}>
                <Link to={"/terms-of-use"}>
                    Terms of use {" "}
                </Link>
                |
                <Link to={"/privacy-policy"}>
                    {" "} Privacy Policy
                </Link>

            </p>
        </footer>

    )
}